import { render } from "./FormatListBulleted.vue?vue&type=template&id=5c444520"
import script from "./FormatListBulleted.vue?vue&type=script&lang=js"
export * from "./FormatListBulleted.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__